module.exports = __webpack_public_path__ + "assets/img/202111-4W.96c43001.png";